import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import {useCurrentAppId} from "crqlar-react-common/dist/utils/hooks/app/useOrganizationApps";
import {useReadOnly} from "crqlar-react-common/dist/utils/hooks/users/useReadOnly";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {ReservationActions, useReservationsState} from "../../../store/reservations.reducer";
import {RightSidebarActionButton} from "../../layout/rightSidebar/RightSidebarRail";
import AddNewPackageReservationsDialog from "../packages/AddNewPackageReservationsDialog";

export function ReservationPackageCreateButton() {
    const {t} = useTranslation();
    const appId = useCurrentAppId();
    const readOnly = useReadOnly();
    const dispatch = useDispatch();
    const {tmpReservationGroupDialogOpen} = useReservationsState(appId);

    const setDialogOpen = (open: boolean) => {
        dispatch({
            type: ReservationActions.SET_RESERVATIONS,
            appId,
            payload: {
                tmpReservationGroupDialogOpen: open,
                tmpReservationGroup: undefined,
                tmpReservationGroupReservations: [],
            },
        });
    };

    if (readOnly) return null;

    return (
        <>
            <RightSidebarActionButton
                icon={<DynamicFeedIcon/>}
                label={t("Add new package reservations")}
                onClick={() => setDialogOpen(true)}
            />

            <AddNewPackageReservationsDialog
                open={tmpReservationGroupDialogOpen}
                onClose={() => setDialogOpen(false)}
            />
        </>
    );
}
